const quartiers = [
  'Upemba',
  'Mwana-Shaba (Katanga)',
  'Nsele',
  'Musumba',
  'Lufira',
  'Kisale',
  'Kaponda Sud',
  'Kaponda Nord',
  'Bukama',
  'Mampala',
  'Gambela',
  'Makutano',
  'Kalubwe',
  'Kiwele',
  'Lumumba',
  'Lido-Golf',
  'Kafubu',
  'Bel Air 1',
  'Bel Air 2',
  'Kigoma',
  'Kampemba',
  'Bongonga',
  'Industriel',
  'Congo',
  'Bendera',
  'Kalukuluku',
  'Makutano',
  'Luano',
  'Kawama',
  'Shindaika',
  'Luapula',
  'Luvua',
  'Lualaba',
  'Njanja',
  'Kitumaini',
  'Kisanga',
  'Kimbembe',
  'Luwoshi',
  'Kasapa',
  'Mavyundu',
  'Munua',
  'Kasungami',
  'Kalebuka',
  'Binza Joli Parc',
  'Binza Kinsuka',
  'Binza Mfuti',
  'Binza Okapi',
  'Binza Pigeon',
  'Boyoma',
  'Camp Bakwanga',
  'Camp Capitaine Luano',
  'Camp Luka',
  'Camp Mombele',
  'Cite Anciens Combattants',
  'Joli Parc',
  'Heradi',
  'Kimbangu',
  'Kingabwa Yaounde',
  'Ma Campagne',
  'Matonge',
  'Mont Ngaliema',
  'Mpasa',
  'Nzenza',
  'Q Bisengo',
  'Q Lingwala',
  'Q Lubudi',
  'Q.Adoula',
  'Quartier 1',
  'Quartier 7',
  'Quartier Bahumbu',
  'Quartier Congo',
  'Quartier du 17 Mai',
  'Quartier Kinzazi',
  'Quartier Kutu',
  'Quartier Malandi 2',
  'Quartier Mangana',
  'Quartier Mikondo',
  'Quartier Mongo',
  'Quartier Mutoto',
  'Quartier Nsanga',
  'Yolo Nord',
];
export {
  quartiers
};



// WEBPACK FOOTER //
// ./src/api/quartiers.js